// extracted by mini-css-extract-plugin
export var contact = "style-module--contact--0ed8f";
export var footer = "style-module--footer--40524";
export var ftn = "style-module--ftn--58d3c";
export var instagram = "style-module--instagram--b2abc";
export var language = "style-module--language--bf9fa";
export var links = "style-module--links--94249";
export var logo = "style-module--logo--e8290";
export var privacy = "style-module--privacy--06b1c";
export var rights = "style-module--rights--67454";